import * as React from "react";
import CommonStreamItem from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {InvoiceActivityItemsType} from "./InvoiceActivityStream";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import InvoiceActivityNoteItem from "./items/InvoiceActivityNoteItem";
import InvoiceUpdatedEvent from "../../../model/invoice/event/InvoiceUpdatedEvent";
import {AccountingCommonActivityUpdatedItem} from "./items/AccountingCommonActivityUpdatedItem";
import Payment from "../../../model/payment/Payment";
import {InvoiceActivityPaymentItem} from "./items/InvoiceActivityPaymentItem";
import InvoiceSentEvent from "../../../model/invoice/event/InvoiceSentEvent";
import InvoiceActivitySentItemWithAction from "./items/InvoiceActivitySentItemWithAction";

interface ComponentProps {
	/**
	 * Invoice activity data.
	 */
	activityItems: InvoiceActivityItemsType[];
	/**
	 * Note id to set active class and focus on it.
	 */
	activeNoteId: string;
	/**
	 * Invoice identifier.
	 */
	invoiceId: string;
	/**
	 * Edit note click action.
	 * @param note note to edit.
	 */
	onEditNoteClick: (note: AccountingNote) => void;
	/**
	 * Delete note success callback.
	 * @param note deleted note.
	 */
	onDeleteNoteSuccess: (note: AccountingNote) => void;
}

type Props = ComponentProps;

/**
 * InvoiceActivityStreamItems component
 */
export default class InvoiceActivityStreamItems extends React.PureComponent<Props, {}> {
	render() {
		return this.props.activityItems.map((activity, index) => {
			return (
				<div className="c-common-details_activity-stream-item-container" key={index}>
					{this.renderItem(activity)}
				</div>
			);
		})
	}

	renderItem = (activity: InvoiceActivityItemsType) => {
		if (activity instanceof AccountingNote) {
			return <InvoiceActivityNoteItem activity={activity}
											isActive={this.isActive(activity.id)}
											invoiceId={this.props.invoiceId}
											onEditNoteClick={this.props.onEditNoteClick}
											onDeleteNoteSuccess={this.props.onDeleteNoteSuccess}/>;
		}
		if (activity instanceof InvoiceUpdatedEvent) {
			return <AccountingCommonActivityUpdatedItem activity={activity}/>;
		}
		if (activity instanceof InvoiceSentEvent) {
			return <InvoiceActivitySentItemWithAction activity={activity}/>;
		}
		if (activity instanceof Payment) {
			return <InvoiceActivityPaymentItem activity={activity}/>;
		}
		return <CommonStreamItem event={activity}/>;
	};

	/**
	 * Check if note is the active one.
	 */
	isActive = (noteId: string): boolean => {
		return this.props.activeNoteId === noteId;
	};
}
